import { create as n } from "./util/create.js";
import { caseInsensitiveTransform as s } from "./util/case-insensitive-transform.js";
const m = n({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: s,
  properties: { xmlns: null, xmlnsXLink: null }
});
export {
  m as xmlns
};
//# sourceMappingURL=xmlns.js.map
